import { createSlice } from '@reduxjs/toolkit'

export const AsyncAssetUploadSlice = createSlice(
    {
        name: 'asset_upload_background',
        initialState: {
          value: {
            messageStatus : "hide",
            pendingFiles : {},
            inProgressFiles : [],
            completedFiles : [],
            validationErrors: [],
            isReadyForValidation:false,
            canSubmitTranslation: true
          }
        },
        reducers: {
          updateAsyncUploadAssetData: (state, action) => {
            state.value = action.payload
          },
          updateAsyncUploadAssetPendingFiles: (state, action) => {            
            state.value.pendingFiles = action.payload
          },
          updateAsyncUploadAssetCompletedFiles: (state, action) => {            
            state.value.completedFiles = action.payload
          },
          updateAsyncUploadAssetInProgressFiles: (state, action) => {            
            state.value.inProgressFiles = action.payload
          },
          updateValidationErrors: (state, action) => {            
            state.value.validationErrors = action.payload
          },
          updateReadyForValidation: (state, action) => {            
            state.value.isReadyForValidation = action.payload
          },
          updateCanSubmitTranslation: (state, action) => {            
            state.value.canSubmitTranslation = action.payload
          }
        },
      })
      
      export const { updateAsyncUploadAssetData,updateAsyncUploadAssetPendingFiles,updateAsyncUploadAssetCompletedFiles, updateAsyncUploadAssetInProgressFiles, updateValidationErrors,updateReadyForValidation, updateCanSubmitTranslation} = AsyncAssetUploadSlice.actions
      
      export default AsyncAssetUploadSlice.reducer